import { useTranslation } from 'react-i18next';
import { isNotStartedSession } from '@/lib/analyticsSessionStatus';
import type { WebinarSessionStatus } from '../types';

interface WebinarStatusTagProps {
  sessionType: 'LIVE' | 'EVERGREEN';
  status?: WebinarSessionStatus | null;
}

const TAG_CLASS = 'px-3 py-1 rounded-full text-[10px] font-semibold tracking-wider w-fit';

export const WebinarStatusTag = ({ sessionType, status }: WebinarStatusTagProps) => {
  const { t } = useTranslation('analytics');
  const isLive = sessionType === 'LIVE';

  return (
    <span className="flex flex-wrap items-center gap-2">
      <span
        className={`${TAG_CLASS} ${
          isLive ? 'surface-decorative-1 text-[#17805C]' : 'surface-decorative-2 text-[#1A4199]'
        }`}
      >
        {isLive ? 'Live' : 'Evergreen'}
      </span>
      {isNotStartedSession(status) && (
        <span className={`${TAG_CLASS} bg-neutral-100 text-role-tertiary`}>
          {t('status.notStarted')}
        </span>
      )}
    </span>
  );
};
